import { readDicomFile } from '~/domain/dicom/engine/reader';
import * as dicomTags from '~/domain/dicom/engine/tags';
import { Modality } from '~/domain/dicom/modality';
import { readStructureSet } from '~/domain/dicom/structureSetReader';
import { DomainValidationError } from '~/domain/errors/DomainError';
import { GenerationModelDetails } from '~/domain/dicom/dicomBase';
import { Image3D } from '~/domain/patient/image3d';
import {
    StructureSet,
    structureSetFromDicom,
} from '~/domain/patient/structureset';

export function readStructureSetsOnImage(
    buffers: readonly ArrayBuffer[],
    image: Image3D,
    generationModel?: GenerationModelDetails
): StructureSet[] {
    const structureSets: StructureSet[] = [];
    for (const buffer of buffers) {
        const file = readDicomFile(buffer);
        if (file.dataset.string(dicomTags.MODALITY) !== Modality.RTSTRUCT) {
            continue;
        }
        const dicomStructureSet = readStructureSet(file);
        if (!dicomStructureSet) {
            throw new DomainValidationError(
                'The structure set references no image series.'
            );
        }
        // Never shown against a scan it was not drawn on.
        if (dicomStructureSet.referencedSeriesUid !== image.seriesUid) {
            throw new DomainValidationError(
                'The structure set was drawn on a different image series.'
            );
        }
        dicomStructureSet.generationModel = generationModel;
        structureSets.push(structureSetFromDicom(dicomStructureSet, image));
    }
    return structureSets;
}
